module.exports = __webpack_public_path__ + "static/media/techforce_logo.2f5c6825.png";